if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();

      this.readMoreToggle = this.querySelector('[data-read-more-toggle]');
      this.readMoreToggle.addEventListener('click', this.toggleExpandedClass.bind(this));
    }

    toggleExpandedClass() {
      this.classList.toggle('read-more--expanded')
    }
  }

  customElements.define('read-more', ReadMore);
}
